import { generateEndpoint } from '@ngtrvu/use-api';
import { createApiCall } from 'lib/base';

const GET_FUND_ORDER_DETAIL = 'GET_FUND_ORDER_DETAIL';

const apiCall = createApiCall(
  GET_FUND_ORDER_DETAIL,
  ({ id }: { id: string }) => ({
    endpoint: generateEndpoint({
      host: `api/admin/orders/${id}`,
      params: {},
    }),
    method: 'GET',
  })
);

export default apiCall;
